"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _principles = require("@kbbcomponentlibrary/principles");

var SVGIcons = _interopRequireWildcard(require("@kbbcomponentlibrary/svgicons"));

/*eslint import/namespace: ['error', { allowComputed: true }]*/
var StyledIcon = (
/*#__PURE__*/
0, _styledBase["default"])('svg', {
  target: "e1qznj4u0",
  label: "StyledIcon"
})("color:", _principles.colors.common.black, ";height:", function (props) {
  return props.size;
}, "px;width:", function (props) {
  return props.size;
}, "px;fill:", function (props) {
  return props.colorFill;
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9JY29uLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWdCZ0MiLCJmaWxlIjoiLi4vc3JjL0ljb24uanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKmVzbGludCBpbXBvcnQvbmFtZXNwYWNlOiBbJ2Vycm9yJywgeyBhbGxvd0NvbXB1dGVkOiB0cnVlIH1dKi9cbi8vIEBmbG93XG5cbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBjb2xvcnMgfSBmcm9tICdAa2JiY29tcG9uZW50bGlicmFyeS9wcmluY2lwbGVzJztcbmltcG9ydCAqIGFzIFNWR0ljb25zIGZyb20gJ0BrYmJjb21wb25lbnRsaWJyYXJ5L3N2Z2ljb25zJztcblxudHlwZSBpY29uUHJvcHMgPSB7XG4gIHNpemU6IG51bWJlcixcbiAgdmlld0JveDogc3RyaW5nLFxuICBjb2xvckZpbGw6IHN0cmluZyxcbiAgY2hpbGRyZW4/OiBSZWFjdC5FbGVtZW50PCo+LFxuICB0eXBlOiBzdHJpbmcsXG59O1xuXG5jb25zdCBTdHlsZWRJY29uID0gc3R5bGVkKCdzdmcnKWBcbiAgY29sb3I6ICR7Y29sb3JzLmNvbW1vbi5ibGFja307XG4gIGhlaWdodDogJHsocHJvcHM6IGljb25Qcm9wcykgPT4gcHJvcHMuc2l6ZX1weDtcbiAgd2lkdGg6ICR7KHByb3BzOiBpY29uUHJvcHMpID0+IHByb3BzLnNpemV9cHg7XG4gIGZpbGw6ICR7KHByb3BzOiBpY29uUHJvcHMpID0+IHByb3BzLmNvbG9yRmlsbH07XG5gO1xuXG4vKiogaW1wb3J0IEljb24gZnJvbSBcIkBrYmJjb21wb25lbnRsaWJyYXJ5L2ljb25cIjsgKi9cbmNvbnN0IEljb24gPSAocHJvcHM6IGljb25Qcm9wcykgPT4ge1xuICBjb25zdCBJY29uQ29tcG9uZW50ID0gU1ZHSWNvbnNbcHJvcHMudHlwZV07XG4gIHJldHVybiAoXG4gICAgPFN0eWxlZEljb24gey4uLnByb3BzfT5cbiAgICAgIDxJY29uQ29tcG9uZW50Lz5cbiAgICA8L1N0eWxlZEljb24+XG4gICk7XG59O1xuXG5JY29uLmRpc3BsYXlOYW1lID0gJ0ljb24nO1xuXG5JY29uLmRlZmF1bHRQcm9wcyA9IHtcbiAgc2l6ZTogMjQsXG4gIGNvbG9yRmlsbDogY29sb3JzLmNvbW1vbi5ibGFjayxcbiAgdmlld0JveDogJzAgMCA1MTIgNTEyJyxcbn07XG5cblxuXG5leHBvcnQgZGVmYXVsdCBJY29uO1xuIl19 */"));
/** import Icon from "@kbbcomponentlibrary/icon"; */

var Icon = function Icon(props) {
  var IconComponent = SVGIcons[props.type];
  return _react["default"].createElement(StyledIcon, props, _react["default"].createElement(IconComponent, null));
};

Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 24,
  colorFill: _principles.colors.common.black,
  viewBox: '0 0 512 512'
};
var _default = Icon;
exports["default"] = _default;
Icon.__docgenInfo = {
  "description": "import Icon from \"@kbbcomponentlibrary/icon\";",
  "methods": [],
  "displayName": "Icon",
  "props": {
    "size": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "required": false,
      "flowType": {
        "name": "number"
      },
      "description": ""
    },
    "colorFill": {
      "defaultValue": {
        "value": "colors.common.black",
        "computed": true
      },
      "required": false,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "viewBox": {
      "defaultValue": {
        "value": "'0 0 512 512'",
        "computed": false
      },
      "required": false,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "children": {
      "required": false,
      "flowType": {
        "name": "ReactElement",
        "raw": "React.Element<*>",
        "elements": [{
          "name": "unknown"
        }]
      },
      "description": ""
    },
    "type": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Icon.js"] = {
    name: "Icon",
    docgenInfo: Icon.__docgenInfo,
    path: "src/Icon.js"
  };
}